export const formatYear = (year: number): string => {
  return year.toString().slice(-2);
};

export const formatMonth = (month: number): string => {
  const str = month.toString();
  return str.length === 1 ? `0${str}` : str;
};
